import _ from 'lodash'

import i18n from '@/i18n/i18n'
import PurchaseService from '@/services/admin/PurchaseService.js'
import { build_query, errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const namespaced = true

export const allowedSorts = '-created_at'
export const allowedFilters = ['name']

export const state = {
  purchases: null,
  purchase: {},
  meta: null
}

export const mutations = {
  SET_PURCHASES(state, purchases) {
    state.purchases = purchases.data
    state.meta = purchases.meta
  },
  SET_PURCHASE(state, purchase) {
    state.purchase = purchase
  },
  ADD_PURCHASE(state, purchase) {
    state.purchases.push(purchase)
  },
  DELETE_PURCHASE(state, purchaseId) {
    state.purchases = _.filter(state.purchases, function (purchase) {
      return purchase.id !== purchaseId
    })
  }
}

export const actions = {
  getPurchases({ commit }, query) {
    let newQuery = build_query(query, allowedFilters, allowedSorts)
    return new Promise(resolve => {
      PurchaseService.getPurchases(newQuery).then(response => {
        commit('SET_PURCHASES', response)
        resolve(response)
      })
    })
  },
  getPurchase({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      PurchaseService.getPurchase(params.purchasePeriodId)
        .then(response => {
          commit('SET_PURCHASE', response.data)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.purchase.get_purchase_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  createPurchase({ commit, dispatch, state }, params) {
    return new Promise((resolve, reject) => {
      PurchaseService.createPurchase(params.purchase)
        .then(response => {
          if (state.purchases) {
            commit('ADD_PURCHASE', response)
          }
          const notification = {
            type: 'success',
            message: t('store.admin.purchase.create_purchase_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.purchase.create_purchase_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  editPurchase({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      PurchaseService.editPurchase(params.purchasePeriodId, params.purchase)
        .then(response => {
          commit('SET_PURCHASE', response.data)
          const notification = {
            type: 'success',
            message: t('store.admin.purchase.edit_purchase_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.purchase.edit_purchase_error')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  deletePurchase({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      PurchaseService.deletePurchase(params.id)
        .then(response => {
          commit('DELETE_PURCHASE', params.id)
          const notification = {
            type: 'success',
            message: t('store.admin.purchase.delete_purchase_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.purchase.delete_purchase_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
